export default __webpack_public_path__ + "static/media/OpenSans-Bold.fa428cdd.ttf";